<div class="lp-collection-statistics">
  <lp-statistics-header
    class="lp-collection-statistics__header"
    [title]="'components.lpCollectionStatistics.labels.title' | translate"
    [description]="'components.lpCollectionStatistics.labels.description' | translate"
    [periodVisible]="false"
  ></lp-statistics-header>

  <div class="lp-collection-statistics__content">
    <tui-island class="widget" [size]="'s'" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
      <div class="tui-island__content">
        <div>
          <p class="tui-island__paragraph">
            {{ 'components.lpCollectionStatistics.labels.collectionViewed' | translate }} –
            <span class="text_bold">{{ statistics?.collectionViewed }}</span>
          </p>
          <p class="tui-island__paragraph">
            {{ 'components.lpCollectionStatistics.labels.collectionProductsViewed' | translate }} –
            <span class="text_bold">{{ statistics?.collectionProductsViewed }}</span>
          </p>
          <p class="tui-island__paragraph">
            {{ 'components.lpCollectionStatistics.labels.collectionViewedFromPush' | translate }} –
            <span class="text_bold">{{ statistics?.collectionViewedFromPush }}</span>
          </p>
          <p class="tui-island__paragraph">
            {{ 'components.lpCollectionStatistics.labels.collectionProductsViewedFromPush' | translate }} –
            <span class="text_bold">{{ statistics?.collectionProductsViewedFromPush }}</span>
          </p>
        </div>
      </div>
    </tui-island>
  </div>
</div>
